import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy ``/workspace/integrations`` index — redirected to the new
 * fullscreen URL. See the parent ``route.tsx`` for the migration
 * rationale.
 */
export const Route = createFileRoute("/_authed/workspace/integrations/")({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/integrations",
      search: search as Record<string, unknown>,
      replace: true,
    });
  },
});
